import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default class DebugGrid {
  constructor() {
    this.scrollToButtons = []
  }

  init() {
    this.scrollToButtons = [...document.querySelectorAll('.js-scrollto')]
    this.scrollToButtons.forEach(button => {
      button.addEventListener('click', this.handleScrollTo)
    })
  }

  handleScrollTo = e => {
    e.preventDefault()
    gsap.to(window, { duration: 1.2, scrollTo: '#main-content', ease: 'power2.inOut' })
  }
}
